import { render, staticRenderFns } from "./ContentEdit.vue?vue&type=template&id=4f56d1a0&scoped=true"
import script from "./ContentEdit.vue?vue&type=script&lang=js"
export * from "./ContentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f56d1a0",
  null
  
)

export default component.exports